import { useCallback, useEffect, useId, useRef } from 'react'
import { Html5Qrcode } from 'html5-qrcode'

export const useQrDecode = () => {
  const scannerElementId = useId()
  const scannerRef = useRef<Html5Qrcode | null>(null)

  const getScanner = useCallback(() => {
    if (!scannerRef.current) {
      scannerRef.current = new Html5Qrcode(scannerElementId, false)
    }

    return scannerRef.current
  }, [scannerElementId])

  // decodeImage обрабатывает один файл за вызов и рендерит изображение в привязанный
  // DOM-элемент, поэтому файлы декодируются последовательно.
  const decodeImage = useCallback(
    async (file: File): Promise<string | null> => {
      try {
        const result = await getScanner().scanFile(file, false)

        return result.trim() || null
      } catch {
        // Библиотека бросает исключение, когда QR не найден.
        return null
      }
    },
    [getScanner]
  )

  useEffect(
    () => () => {
      try {
        scannerRef.current?.clear()
      } catch {
        // Элемент уже размонтирован — очищать нечего.
      }
      scannerRef.current = null
    },
    []
  )

  return { decodeImage, scannerElementId }
}
